import Paper from '@/assets/paper.png';
import Rock from '@/assets/rock.png';
import Scissors from '@/assets/scissors.png';

const ROCK = 'rock';
const SCISSORS = 'scissors';
const PAPER = 'paper';

export const WINNER = 'winner';
export const TIE = 'tie';

export const ACTIVE_PLAYER = {
	you: { id: 'you', label: 'You' },
	computer: { id: 'computer', label: 'Nexi' },
};

export const ANSWERS_MAP = {
	//[YOU][COMPUTER]
	[ROCK]: {
		[ROCK]: TIE,
		[SCISSORS]: ACTIVE_PLAYER.you.id,
		[PAPER]: ACTIVE_PLAYER.computer.id,
	},
	[SCISSORS]: {
		[SCISSORS]: TIE,
		[ROCK]: ACTIVE_PLAYER.computer.id,
		[PAPER]: ACTIVE_PLAYER.you.id,
	},
	[PAPER]: {
		[PAPER]: TIE,
		[ROCK]: ACTIVE_PLAYER.you.id,
		[SCISSORS]: ACTIVE_PLAYER.computer.id,
	},
};

export const SCORE_IDX_MAP = {
	[ACTIVE_PLAYER.you.id]: 0,
	[ACTIVE_PLAYER.computer.id]: 1,
};

export const ANIMATION_ANSWERS = {
	[WINNER]: 'animate__animated animate__pulse animate__repeat-2',
	[TIE]: 'animate__animated animate__headShake animate__repeat-2',
};

export default [
	{
		id: ROCK,
		text: 'Rock',
		img: Rock,
		color: 'sunset-coral',
	},
	{
		id: SCISSORS,
		text: 'Scissors',
		img: Scissors,
		color: 'teal-tide',
	},
	{
		id: PAPER,
		text: 'Paper',
		img: Paper,
		color: 'bahay-kubo',
	},
];
